<template>
  <div class="page-wrap ai-prediction">
    <MCard title="AI 未来一周趋势预测">
      <template #header>
        <!-- <span class="m-card_header-title_left">{{ titleLeft }}</span> -->
        <span class="m-card_header-title">AI 未来一周趋势预测（演示）</span>
      </template>

      <div class="ai-prediction-info">
        <span v-for="(info, i) in infoList" :key="i">{{ info }}</span>
      </div>

      <MTable v-bind="tableConfig">
        <template #expand="{ props }">
          <div class="ai-prediction_chart-wrap">
            <v-chart
              :options="makeChartOptions(props.row.graphValList, props.row)"
              :autoresize="true"
            />
          </div>
        </template>

        <template #day="{ row, config }">
          <div>
            <span>
              {{ row[config.prop] == 40 ? 'UD' : row[config.prop] }}
            </span>
            <br />
            <span>{{ row[`${config.prop}date`] }}</span>
          </div>
        </template>
      </MTable>
    </MCard>
  </div>
</template>

<script>
import MTable from '@/components/mTable/m-table.vue';
import MCard from '@/components/mCard/index.vue';
// import { randomRangeInt } from '@/utils/math';
import { formatTime } from '@/utils/date';
import { getAiTrainingList, getPredictAIResult } from '@/api/RTEAO';
import { List } from '@/utils/List';

export default {
  components: {
    MTable,
    MCard
  },
  data() {
    return {
      latestVersion: '',
      rawData: [
        // {
        //   officeId: 'NodeAA',
        //   officeName: 'NodeAA',
        //   list: [
        //     {
        //       pathogenName: '病毒AA',
        //       past: Array(30)
        //         .fill(null)
        //         .map((_, i) => ({
        //           dt: new Date(2025, 9, i + 1 + 9).toLocaleDateString('en-CA', {
        //             year: 'numeric', // 4位年份（如 2024）
        //             month: '2-digit', // 2位月份（如 01、12）
        //             day: '2-digit' // 2位日期（如 05、31）
        //           }),
        //           pathogenState: '1',
        //           proportion: randomRangeInt(0, 100),
        //           trend: randomRangeInt(0, 2)
        //         })),
        //       prediction: Array(7)
        //         .fill(null)
        //         .map((_, i) => ({
        //           dt: new Date(2025, 10, i + 1 + 9).toLocaleDateString('en-CA', {
        //             year: 'numeric', // 4位年份（如 2024）
        //             month: '2-digit', // 2位月份（如 01、12）
        //             day: '2-digit' // 2位日期（如 05、31）
        //           }),
        //           pathogenState: '1',
        //           proportion: randomRangeInt(0, 100),
        //           trend: randomRangeInt(0, 2)
        //         }))
        //     }
        //   ]
        // }
      ],
      tableConfig: {
        loading: false,
        height: '100%',
        hasPagination: false,
        hasExpand: true,
        defaultExpandAll: true,
        tableData: [],
        tableColumn: [
          {
            label: '节点名称',
            prop: 'officeName'
          },
          {
            label: '病毒名称',
            prop: 'pathogenName'
          },
          // {
          //   label: '指标',
          //   prop: 'indexName'
          // },
          {
            label: '第一天',
            prop: 'day1',
            slot: 'day'
            // temp
          },
          {
            label: '第二天',
            prop: 'day2',
            slot: 'day'
          },
          {
            label: '第三天',
            prop: 'day3',
            slot: 'day'
          },
          {
            label: '第四天',
            prop: 'day4',
            slot: 'day'
          },
          {
            label: '第五天',
            prop: 'day5',
            slot: 'day'
          },
          {
            label: '第六天',
            prop: 'day6',
            slot: 'day'
          },
          {
            label: '第七天',
            prop: 'day7',
            slot: 'day'
          }
        ]
      }
    };
  },
  computed: {
    infoList() {
      const text = this.latestVersion ? `${this.latestVersion}` : '';

      const date = new Date();
      date.setHours(2, 10, 0, 0);

      return [
        `报告时间: ${formatTime(date, 'yyyy-MM-dd hh:mm')}`,
        `模型名称: HT-EAO`,
        `模型版本: ${text}`
      ];
    }
  },
  methods: {
    async initLatestVersion() {
      try {
        const res = await getAiTrainingList();

        if (res.code !== 200) return;

        this.latestVersion = res.data.find(e => e.isCurrVersion === '1').version;
      } catch (error) {
        console.log(error);
      }
    },
    async initData() {
      try {
        this.tableConfig.loading = true;
        const res = await getPredictAIResult({});

        if (res.code !== 200) return;

        this.rawData.splice(0, Infinity, ...res.data);
      } catch (error) {
        console.log(error);
      } finally {
        this.tableConfig.loading = false;
      }
    },
    async handleData(n) {
      this.tableConfig.tableData.splice(0, Infinity);

      n.forEach(item => {
        // const indexDict = {
        //   proportion: '阳性数量'
        // };

        item.list.forEach(item2 => {
          // Object.keys(indexDict).forEach(index => {
          const row = {
            officeId: item.officeId,
            officeName: item.officeName,
            pathogenName: item2.pathogenName,
            trend: item2.trend,
            pastLen: new List(item2.past).groupBy('dt').list.length
          };

          this.tableConfig.tableData.push(row);

          row.graphValList = item2.past
            .map(e => [e.dt, e.proportion >= 40 ? 40 : e.proportion])
            .sort((a, b) => new Date(a[0]) - new Date(b[0]));

          item2.prediction.forEach((resultItem, i) => {
            row[`day${i + 1}`] = resultItem.proportion >= 40 ? 40 : resultItem.proportion;
            row[`day${i + 1}trend`] = resultItem.trend;
            row[`day${i + 1}date`] = formatTime(resultItem.dt, 'MM-dd');

            row.graphValList.push([
              resultItem.dt,
              resultItem.proportion >= 40 ? 40 : resultItem.proportion
            ]);
          });
        });
        // });
      });
    },
    makeChartOptions(data, { pastLen, trend }) {
      const rootFs = 26;
      const getFs = rem => rootFs * rem;

      return {
        color: ['#04d7ff'],
        title: {
          left: 'center'
        },
        grid: {
          left: '5%',
          right: '5%',
          top: '15%',
          bottom: '2%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          show: false,
          type: 'scroll',
          right: 10,
          top: 20,
          bottom: 20,
          textStyle: {
            color: '#fff'
          }
        },
        xAxis: {
          type: 'category',
          show: true,
          boundaryGap: false,
          axisLabel: {
            fontSize: getFs(1)
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: '#283763'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#04d7ff'
            }
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false
          },
          axisLabel: {
            fontSize: getFs(1)
          },
          axisLine: {
            lineStyle: {
              color: '#04d7ff'
            }
          },
          min: () => {
            return 20;
          },
          max: () => {
            return 40;
          }
        },
        // visualMap: {
        //   show: false,
        //   dimension: 0,
        //   pieces: [
        //     {
        //       gt: pastLen - 1,
        //       lte: pastLen + 7,
        //       color: '#007bff'
        //     },
        //     {
        //       lte: pastLen,
        //       color: '#87CEEB'
        //     }
        //   ]
        // },
        series: [
          {
            type: 'line',
            // smooth: true,
            symbol: 'circle',
            symbolSize: 10,
            data,
            markArea: {
              itemStyle: {
                color: trend < 2 ? 'rgba(3, 179, 110, 0.3)' : 'rgba(255, 97, 0, 0.36)'
              },
              data: [
                [
                  {
                    name: '预测' + ['阳性率下降', '阳性率平稳', '阳性率升高'][trend],
                    xAxis: pastLen,
                    label: {
                      fontSize: getFs(1.125),
                      color: trend < 2 ? 'rgba(3, 179, 110, 0.9)' : 'rgba(255, 97, 0, 0.9)'
                    }
                  },
                  {
                    xAxis: pastLen + 7
                  }
                ]
              ]
            },
            itemStyle: {
              color: ({ value }) => {
                return value[1] < 40 ? 'orange' : '#aaa';
              }
            }
          }
        ]
      };
    }
  },
  async mounted() {
    this.initLatestVersion();

    await this.initData();
    this.handleData(this.rawData);
  }
};
</script>

<style lang="scss">
.ai-prediction {
  .m-table {
    height: calc(100% - 58px);
  }

  &_chart-wrap {
    height: 260px;
  }

  .m-card_header-title {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);

    &_left {
      font-size: 1.2rem;

      white-space: pre-line;
    }
  }

  .ai-prediction-info {
    display: flex;
    // flex-direction: column;
    gap: 30px;

    font-size: 1.2rem;

    padding: 10px 20px;
  }

  .cell {
    span {
      white-space: pre-line;
    }
  }
}
</style>
